import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { isMobile, isTablet, MobileView, BrowserView } from 'react-device-detect'
import ReactRouterPropTypes from 'react-router-prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import styled from 'styled-components'
import { Divider, Row, Col, Empty } from 'core/components/ui'
import { withRouter } from 'react-router-dom'
import useGetCar from 'core/hooks/useGetCar'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import * as routes from 'core/routing/constants/index'
import PageLoading from 'core/components/page-loading'
import TitleIcon from 'core/layouts/title-icon'
import wizardsShape from 'core/components/wizard/shapes'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font, greys, fontFamily } from 'assets/themes/theme-default'

import ColorMaterial, { CoatingColor } from 'core/utils/enums/colors'

import Interior from './interior'
import Paints from './paints'
import { tradeInShape } from '../shapes'

const DISPLAY_COLORS_REF = 6

const InterTitle = styled.h3`
  font-size: ${font.size.lgxxs};

  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  margin: ${isMobile ? '10px 0' : '0 0 10px 0'};
`

const RenderColor = styled(Row)`
  > div {
    height: 100%;
    width: 100%;
    background-color: ${props => props.color};
    background: ${props => props.url};
  }
  width: 90px;
  height: 50px;
  margin-bottom: 0px;
  cursor: pointer;
  position: relative;
  padding: 2px;
  max-width: 100%;
`
const RenderColorLabel = styled.p`
  color: ${greys.dark3};
  font-size: ${font.size.base};
  text-align: center;
  ${isMobile && 'margin-bottom: 5px;'}
`
const CheckedIcon = styled(SVG)`
  width: 20px;
  fill: ${props => props.theme.colors.color1.bg};
  margin-right: 10px;
  z-index: 3;
  position: absolute;
  top: 50%;
  right: 50%;
  margin: -10px -10px 0 0;
  border: 2px solid ${greys.light4};
  border-radius: 20px;
`
const PaletteIcon = styled(SVG)`
  width: 30px;
  margin-right: 10px;
  z-index: 2;
  position: absolute;
  top: 50%;
  right: 50%;
  margin: -15px -15px 0 0;
`

const DividerStyled = styled(Divider)`
  &&& {
    background-color: ${props => props.theme.colors.color1.bg};
    margin: 15px 0px 15px -10px;
  }
`

const StyledLink = styled.a`
  text-decoration: underline;
`
const Title = styled.h4`
  font-weight: ${font.weight.base};
  font-size: ${font.size.lg};

  margin: 30px 0 15px 0;
`
const Colors = props => {
  const { tradeIn, setTradeIn, intl, setWizards, wizards, history, configuration } = props
  const { tradeInContext } = configuration

  const { getCarColors, getCarDesign, carDesigns, loading, carColors } = useGetCar({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const { vehicle, filtersList } = tradeIn
  const {
    id,
    wsDatas,
    colors,
    makeId,
    modelId,
    externalColorWording,
    internalColorWording
  } = vehicle
  const { colorsList } = filtersList
  const { exterior, interior } = colorsList
  const [displayMoreExternalColors, setDisplayMoreExternalColors] = useState(false)
  const [displayMoreInternalColors, setDisplayMoreInternalColors] = useState(false)

  const handleClickSeeMoreColors = type => {
    if (type === 1) {
      setDisplayMoreExternalColors(!displayMoreExternalColors)
    } else {
      setDisplayMoreInternalColors(!displayMoreInternalColors)
    }
  }

  const handleOnChangeSelectionColor = (type, value) => {
    let extendedColors

    switch (type) {
      case 1:
        extendedColors = { ...colors, exterior: value }
        break
      case 2:
        extendedColors = { ...colors, interior: value }
        break
      default:
        break
    }

    const extendedVehicle = { ...vehicle, colors: extendedColors }

    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  const renderListColors = type => {
    const exteriorList = colorsList.exterior
    const interiorList = colorsList.interior

    let colorsListToDisplay
    let itemSelected
    let displayMoreColors

    switch (type) {
      case 2:
        colorsListToDisplay = interiorList
        itemSelected = colors.interior
        displayMoreColors = displayMoreInternalColors

        break
      case 1:
      default:
        colorsListToDisplay = exteriorList
        itemSelected = colors.exterior

        displayMoreColors = displayMoreExternalColors

        break
    }

    return (
      <Row type="flex" gutter={10}>
        {colorsListToDisplay.map((item, index) => {
          if (!displayMoreColors && index > DISPLAY_COLORS_REF) {
            return false
          }

          const currentType = item.external ? CoatingColor.POLISH_COLOR : CoatingColor.FABRIC_COLOR
          const currentColors = ColorMaterial[currentType]

          const currentColor = _.first(
            currentColors.items.filter(color => color.hexaDecimal === item.reference)
          )
          const { url } = currentColor

          return (
            <Col
              key={item.wording}
              lg={4}
              sm={5}
              xs={6}
              onClick={() => handleOnChangeSelectionColor(type, item)}
              align="center"
            >
              <RenderColor
                color={item.reference ? `#${item.reference}` : '#FFF'}
                type="flex"
                align="middle"
                justify="center"
                url={url}
              >
                <div>
                  {!item.reference && <PaletteIcon svg={svg.palette} />}
                  <TransitionGroup>
                    {itemSelected && itemSelected.wording === item.wording && (
                      <CSSTransition
                        key="checkedColor"
                        classNames="fade"
                        timeout={{ enter: 2200, exit: 200 }}
                      >
                        <CheckedIcon svg={svg.checked} />
                      </CSSTransition>
                    )}
                  </TransitionGroup>
                </div>
              </RenderColor>

              <RenderColorLabel>{item.wording}</RenderColorLabel>
            </Col>
          )
        })}
        <Col span={24}>
          <StyledLink onClick={() => handleClickSeeMoreColors(type)}>
            {intl.formatMessage({
              id: !displayMoreColors
                ? 'tradeIn-colors-displayMore-state1'
                : 'tradeIn-colors-displayMore-state2'
            })}
          </StyledLink>
        </Col>
      </Row>
    )
  }

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_COLORS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  useEffect(() => {
    const runIt = c => {
      const externalColors = c.map(item => ({ ...item, external: false }))
      //
      const extendedFiltersList = {
        ...filtersList,
        colorsList: {
          exterior: [...c],
          interior: [...externalColors]
        }
      }

      let extendedVehicle = vehicle

      let ext = null

      if (externalColorWording) {
        ext = _.first(
          c.filter(color =>
            externalColorWording.toUpperCase().includes(color.wording.toUpperCase())
          )
        )
      }

      let int = null
      if (internalColorWording) {
        int = _.first(
          c.filter(color =>
            internalColorWording.toUpperCase().includes(color.wording.toUpperCase())
          )
        )
      }

      let extendedColors = { ...vehicle.colors }
      if (ext) {
        extendedColors = {
          ...extendedColors,
          exterior: ext
        }
      }

      if (int) {
        extendedColors = {
          ...extendedColors,
          interior: int
        }
      }

      extendedVehicle = {
        ...extendedVehicle,
        colors: extendedColors
      }

      setTradeIn({
        ...tradeIn,
        filtersList: extendedFiltersList,
        vehicle: extendedVehicle
      })
    }
    if (carColors && !tradeInContext.loading) runIt(carColors)
  }, [carColors])

  useEffect(() => {
    const runIt = list => {
      const serialLeathers = list.interior.leathers.filter(item => item.serial)
      const serialFabrics = list.interior.fabrics.filter(item => item.serial)

      let serialInteriors = serialLeathers.concat(serialFabrics)
      let serialPaints = null

      if (list.interior.leathers.length === 0 && list.interior.fabrics.length === 0) {
        serialInteriors = [
          { id: 'default', label: intl.formatMessage({ id: 'standard_upholstery' }) }
        ]
      }

      const extendedFiltersList = {
        ...filtersList,
        designList: list
      }
      let extendedVehicle = vehicle

      if (!vehicle.colors.type) {
        if (!_.isEmpty(vehicle.painting)) {
          serialPaints = { equipment: vehicle.painting.equipment }
        } else if (!vehicle.colors.type && list.exterior.type.filter(x => x.serial).length !== 1) {
          serialPaints = { equipment: intl.formatMessage({ id: 'standard_painting' }) }
        } else {
          serialPaints = _.first(list.exterior.type.filter(item => item.serial))
        }
        /* const extendedDesign = {
          ...carDesigns,
          interior: serialInteriors,
          exterior: extendedExterior
        }*/

        extendedVehicle = {
          ...vehicle,
          colors: {
            ...vehicle.colors,
            type: serialPaints || null
          },
          interior: serialInteriors
        }
      }

      setTradeIn({
        ...tradeIn,
        filtersList: extendedFiltersList,
        vehicle: extendedVehicle
      })
    }

    if (carDesigns && !tradeInContext.loading) runIt(carDesigns)
  }, [carDesigns])

  useEffect(() => {
    if (carColors && colors.exterior && colors.interior) {
      activateNextStep()
    }
  }, [colors.exterior, colors.interior])

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.TRADEIN_COLORS)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    if (!tradeInContext.loading) {
      // load datas
      const { catalogPriceBegin } = wsDatas
      const params = { makeId, modelId }
      const paramsDesign = { id, catalog: catalogPriceBegin }

      getCarColors(params)
      getCarDesign(paramsDesign)
    }
  }, [])

  return (
    <MainContentWrapper>
      <>
        <TitleIcon
          cssId="globaldealer-title-3"
          title={intl.formatMessage({
            id: 'tradeIn-colors-subtitle'
          })}
        />

        <BrowserView>
          {loading ? (
            <PageLoading />
          ) : (
            <>
              <Row type="flex" gutter={100}>
                <Col lg={12} xs={24} sm={12}>
                  <InterTitle>
                    <FormattedMessage id="tradeIn-colors-typeColor-1" />
                  </InterTitle>
                  {loading && <PageLoading />}
                  {!loading ? (
                    <Paints data-test="configurator-design-interior" loading={loading} />
                  ) : (
                    <Empty />
                  )}
                </Col>
                <Col lg={12} xs={24} sm={12}>
                  {loading && !interior && !exterior && <PageLoading />}
                  {!loading && exterior ? renderListColors(1) : <Empty />}
                </Col>
              </Row>
              <DividerStyled />
              <Row style={{ marginTop: '24px' }} type="flex" gutter={100}>
                <Col lg={12} xs={24} sm={12}>
                  <InterTitle>
                    <FormattedMessage id="tradeIn-colors-typeColor-2" />
                  </InterTitle>
                  {loading && !interior && !exterior && <PageLoading />}
                  {!loading && interior ? renderListColors(2) : <Empty />}
                </Col>
                <Col lg={12} xs={24} sm={12}>
                  <InterTitle>
                    <FormattedMessage id="configurator-design-card-2-title" />
                  </InterTitle>
                  {loading && <PageLoading />}
                  {!loading ? (
                    <Interior data-test="configurator-design-interior" loading={loading} />
                  ) : (
                    <Empty />
                  )}
                </Col>
              </Row>
            </>
          )}
        </BrowserView>
        {!isTablet && (
          <MobileView>
            {loading && <PageLoading />}
            {!loading ? (
              <>
                <Title>
                  <FormattedMessage id="paint" />
                </Title>
                <Paints data-test="configurator-design-interior" loading={loading} />
              </>
            ) : (
              <Empty />
            )}
            {loading && !interior && !exterior && <PageLoading />}
            {!loading && exterior ? (
              <>
                <Title>
                  <FormattedMessage id="tradeIn-colors-typeColor-1" />
                </Title>
                {renderListColors(1)}
              </>
            ) : (
              <Empty />
            )}
            {loading && !interior && !exterior && <PageLoading />}
            {!loading && interior ? (
              <>
                <Title>
                  <FormattedMessage id="tradeIn-colors-typeColor-2" />
                </Title>
                {renderListColors(2)}
              </>
            ) : (
              <Empty />
            )}
            {loading && <PageLoading />}
            {!loading ? (
              <Interior data-test="configurator-design-interior" loading={loading} />
            ) : (
              <Empty />
            )}
          </MobileView>
        )}
      </>
    </MainContentWrapper>
  )
}

Colors.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  configuration: PropTypes.shape().isRequired
}

export default withRouter(injectIntl(Colors))
